// WhoWeAreSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Figures provided by the client.
const stats = [
  { value: '400', suffix: '+', label: 'People supported in their homes' },
  { value: '05', suffix: '', label: 'Years of trusted local service' },
  { value: '96', suffix: '%', label: 'Family satisfaction rate' },
];

const WhoWeAreSection = () => {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-6">
          Who We Are
        </p>
        <h2 className="font-display font-light text-bnInk leading-snug text-3xl md:text-4xl lg:text-[2.9rem]">
          We are here to uplift care experiences for individuals, families, and providers
          {' '}
          <span className="inline-block bg-bnAccent text-white px-3 py-0.5 rounded-md">one standard</span>
          {' '}at a time.
        </h2>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-6 mt-16 max-w-3xl mx-auto">
          {stats.map((s) => (
            <div key={s.label} className="sm:border-r sm:last:border-r-0 border-bnBorder px-4">
              <p className="font-display font-light text-bnInk text-5xl md:text-6xl leading-none">
                {s.value}
                <span className="text-bnAccent text-2xl align-top ml-0.5">{s.suffix}</span>
              </p>
              <p className="text-bnBody text-sm mt-3 leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-14">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 border border-bnBorder text-bnInk hover:border-bnAccent hover:text-bnAccent font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
          >
            Learn More
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection;
